<template lang="pug">
    .changeBundleNo
        el-dialog(:visible.sync="visible" width="70%" center :before-close="onClose")
            .dailog-title(slot="title") 
                h3 修改商品信息
            el-table(:data="list" )
                el-table-column(prop="itemTitle" label="商品" min-width="100")
                    template(slot-scope="scope")
                        .goods-name {{scope.row.itemTitle}}
                        .goods-no 商品编号：{{scope.row.itemId}}
                        div.goods-no(v-if="scope.row.supplierName") {{scope.row.supplierName}}
                        el-tag.m-t10.tag(v-if="scope.row.bizOrder.containerFuturesGoods"
                            effect="plain" size="small" type="warning") 预售
                el-table-column(label="商品属性" align="center" min-width="120px")
                    template(slot-scope="scope")
                        .c-9.text-l
                            p.sku-title 单件重: &nbsp;
                                span.c-3 {{scope.row.bizOrder.pieceWeight / 10000}}{{ scope.row.bizOrder.pieceWeightUnit | exUnitToWeight}}
                            p.sku-title.flex(v-for="(item, index) in scope.row.skuTitleList" :key="index")
                              span {{item.split(':')[0]}}:
                              span.c-3(v-if="item.length < 14") {{item.split(':')[1] || '-'}}
                              el-tooltip.max-len(v-else placement="top" :content="item.split(':')[1]") 
                                span {{item.split(':')[1] || '-'}}
                            p.sku-title 仓库: &nbsp;
                                span.c-3 {{scope.row.warehouseName}}
                el-table-column(label="单价" align="center")
                    template(slot-scope="scope")
                        template(v-if="scope.row.bizOrder.logisticsPrice || scope.row.bizOrder.processFee || scope.row.bizOrder.storageFee || scope.row.bizOrder.commissionFee || scope.row.bizOrder.promiseInterestSubsidyFee || scope.row.bizOrder.settleAdjustFee")
                            p {{ (scope.row.itemPrice + scope.row.bizOrder.logisticsPrice + scope.row.bizOrder.processFee + scope.row.bizOrder.storageFee + scope.row.bizOrder.commissionFee + scope.row.bizOrder.promiseInterestSubsidyFee + scope.row.bizOrder.settleAdjustFee) / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                            zg-info
                            div(slot="content")
                                div 商品单价：{{ scope.row.itemPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                                div(v-if='scope.row.bizOrder.logisticsPrice') 胖猫物流费：{{ scope.row.bizOrder.logisticsPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                                div(v-if='scope.row.bizOrder.processFee') 加工费：{{ scope.row.bizOrder.processFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                                div(v-if='scope.row.bizOrder.storageFee') 仓储费：{{ scope.row.bizOrder.storageFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                                div(v-if='scope.row.bizOrder.commissionFee') 委托物流费：{{ scope.row.bizOrder.commissionFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                                div(v-if='scope.row.bizOrder.promiseInterestSubsidyFee') 承兑贴息费：{{ scope.row.bizOrder.promiseInterestSubsidyFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                                div(v-if='scope.row.bizOrder.settleAdjustFee') 结算调差费：{{ scope.row.bizOrder.settleAdjustFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                        template(v-else)
                            p {{ scope.row.itemPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit}}
                el-table-column(label="数量" align="center" prop="buyAmount")
                el-table-column(label="重量" align="center")
                    template(slot-scope="scope")
                        p {{scope.row.bizOrder.totalWeight / 10000}}{{ scope.row.bizOrder.pieceWeightUnit | exUnitToWeight }}
          
                el-table-column(prop="bundleNo" label="捆包号" min-width="100")
                    template(slot-scope="scope" v-if="scope.row.bizOrder")
                        el-input(class="cell-input m-r5" placeholder="请输入" v-model="scope.row.bizOrder.bundleNo")
            .dialog-footer(slot="footer")
                el-button(@click="onClose") 取 消
                el-button(type="primary" @click="confirm") 确 认


</template>

<script>
export default {
  props: {
    visible: Boolean,
    updateBundleInfo: Object
  },
  watch: {
    visible: {
      handler(value) {
        if (value) {
          if (this.updateBundleInfo && Object.keys(this.updateBundleInfo).length) {
            this.list = [this.updateBundleInfo]
          } else {
            this.list = [{}]
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false)
      this.isShowDialog = false
    },
    confirm() {
      let param = {
        bizOrderId: +this.$route.params.id,
        subBizOrderId: +this.list[0].bizOrder.bizOrderId,
        bundleNo: this.list[0].bizOrder.bundleNo
      }
      this.updateBizOrderDetailBundleNo({
        bundleNoUpdate: param
      })
    },
    async updateBizOrderDetailBundleNo(params) {
      try {
        let { success, data } = await this.$post(
          'trademanager.updateBizOrderDetailBundleNo',
          params
        )
        if (success) {
          if (data[0].isSuccess) {
            await this.$message.success('修改商品信息成功')
            this.onClose()
            this.$emit('fetch')
          } else {
            this.$message.error(data[0].errorMessage)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="stylus">
.c-9
    text-align left
.max-len
  display inline-block
  width 80px
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
</style>
